module.exports = __webpack_public_path__ + "static/img/wx-code.51db49b7.png";